export * as incentives from './incentives'; // must be imported for local function access

export function parseNumber(number: any): number | undefined {
    if (!number && number !== '0' && number !== 0) {
        return;
    }

    return Number(number);
}

export * from './pdfUtils';
export * from './rollToUtils';
export * from './shopperUtils';
export * from './dxgUtils';
export * from './paymentUtils';
export * from './dueAtSigningUtils';
export * from './leaseDueAtSigningBreakdown';
export * from './hasOfferPriceChanged';
export * from './leaseContractFieldsUtils';
export * from './creditUtils';
export * from './incentivesUtils';
export * from './termIdParser';
export * from './termsUtils';
export * from './rateUtils';
export * from './equityAllocationUtils';
export * from './lenderProgramUtils';
